
export const loadpageview = (pathname, initialload) => {
    
    
    let useURL = pathname

    try {

        if(pathname.includes('/mass-messenger/sentdetails/')) {
            // convert 'mass-messenger/298462/sentdetails/*' to /mass-messenger/sentdetails/*
            let urlParts = pathname.split('/')
            useURL = `/${urlParts[1]}/${urlParts[2]}/${urlParts[4]}`
        }
        if(pathname.includes('/analytics/')) {
            // convert '/analytics/12345/123345' to /analytics
            let urlParts = pathname.split('/')
            useURL = `/${urlParts[1]}`
        }
        if(pathname.includes('/contacts/') && pathname.includes('/info/activity') ) {
            // convert '/contacts/263282/info/activity/*' to /contacts/info/activity/*
            let urlParts = pathname.split('/')
            useURL = `/${urlParts[1]}/${urlParts[3]}/${urlParts[4]}/${urlParts[5]}`
        }
        if(pathname.includes('/contacts/') && pathname.includes('/info/notes') ) {
            // convert '/contacts/263282/info/notes' to /contacts/info/notes
            let urlParts = pathname.split('/')
            useURL = `/${urlParts[1]}/${urlParts[3]}/${urlParts[4]}`
        }

        if(pathname.includes('/lists/') ) {
            // convert '/lists/263282' to /lists
            let urlParts = pathname.split('/')
            useURL = `/${urlParts[1]}`
        }

        if(pathname.includes('/importer/contacts/results/') ) {
            // convert '/importer/contacts/results/asdfjasdf' to /importer/contacts/results
            let urlParts = pathname.split('/')
            useURL = `/${urlParts[1]}/${urlParts[2]}/${urlParts[3]}`
        }
        
        if(pathname.includes('/coach/') && pathname.includes('/dashboard') ) {
            // convert '/coach/1176/dashboard' to /coach/dashboard
            let urlParts = pathname.split('/')
            useURL = `/${urlParts[1]}/${urlParts[3]}`
        }

        if(pathname.includes('/coach/') && pathname.includes('/lists') ) {
            // convert '/coach/1176/dashboard' to /coach/dashboard
            let urlParts = pathname.split('/')
            useURL = `/${urlParts[1]}/${urlParts[3]}`
        }

        if(pathname.includes('/coach/') && pathname.includes('/mass-messenger/create/messenger/') ) {
            // convert '/coach/1176/mass-messenger/create/messenger/*' /coach/mass-messenger/create/messenger/*
            let urlParts = pathname.split('/')
            useURL = `/${urlParts[1]}/${urlParts[3]}/${urlParts[4]}/${urlParts[5]}/${urlParts[6]}`
        }

        if(pathname.includes('/coach/') && pathname.includes('/mass-messenger/create/recipients') ) {
            // convert '/coach/1176/mass-messenger/create/recipients' /coach/mass-messenger/create/recipients
            let urlParts = pathname.split('/')
            useURL = `/${urlParts[1]}/${urlParts[3]}/${urlParts[4]}/${urlParts[5]}`
        }

        if(pathname.includes('/coach/') && pathname.includes('/mass-messenger/scheduled') ) {
            // convert '/coach/1176/mass-messenger/scheduled' /coach/mass-messenger/scheduled
            let urlParts = pathname.split('/')
            useURL = `/${urlParts[1]}/${urlParts[3]}/${urlParts[4]}`
        }

        if(pathname.includes('/coach/') && pathname.includes('/mass-messenger/sent') ) {
            // convert '/coach/1176/mass-messenger/sent' /coach/mass-messenger/sent
            let urlParts = pathname.split('/')
            useURL = `/${urlParts[1]}/${urlParts[3]}/${urlParts[4]}`
        }

        if(pathname.includes('/coach/') && pathname.includes('/contacts') ) {
            // convert '/coach/1176/contacts' /coach/contacts
            let urlParts = pathname.split('/')
            useURL = `/${urlParts[1]}/${urlParts[3]}`
        }

        if(pathname.includes('/coach/') && pathname.includes('/boards') ) {
            // convert '/coach/1176/contacts' /coach/contacts
            let urlParts = pathname.split('/')
            useURL = `/${urlParts[1]}/${urlParts[3]}`
        }

        if(pathname.includes('/coach/') && pathname.includes('/analytics') ) {
            // convert '/coach/1176/boards' /coach/boards
            let urlParts = pathname.split('/')
            useURL = `/${urlParts[1]}/${urlParts[3]}`
        }

        if(pathname.includes('/coach/') && pathname.includes('/file-storage/import') ) {
            // convert '/coach/1176/file-storage/import' /coach/file-storage/import
            let urlParts = pathname.split('/')
            useURL = `/${urlParts[1]}/${urlParts[3]}/${urlParts[4]}`
        }

        if(pathname.includes('/coach/') && pathname.includes('/file-storage/storage') ) {
            // convert '/coach/1176/file-storage/storage' /coach/file-storage/storage
            let urlParts = pathname.split('/')
            useURL = `/${urlParts[1]}/${urlParts[3]}/${urlParts[4]}`
        }
        
        if(pathname.includes('/coach/') && pathname.includes('/settings/') ) {
            // convert '/coach/1169/settings/*' /coach/settings/*
            let urlParts = pathname.split('/')
            useURL = `/${urlParts[1]}/${urlParts[3]}/${urlParts[4]}`
        }

        if (initialload) {
            //do something special on initial load
        }
    }
    catch (e) {
        //catch any errors and ignore them
    }

    window.gtag('event', useURL)
    
    //console.log(`Original URL:${pathname} Parsed URL:${useURL}`)
}